module.exports = __webpack_public_path__ + "img/08_full.bdbf89a6.jpg";